export const useRuntimeConfig = () => {
  if (typeof window !== 'undefined') {
    return (window as any).runtimeConfig
  }

  return undefined
}
